import { FileUpload } from './fileUpload.model';
export class Roadbook {
    id: string;
    name: string;
    code: string;
    visible: boolean;
    activation_code: string;
    roadbook_type: number;
    roadbook: string;
    filename: string;
    filenameGuide?: string;
    filenameGpx?: string;
    interes?: string;
    distancia?: number;
    duracio?: number;
    estacionalitat?: string;
    geolocalitzacio?: string;
    geolocalitzacio2?: string;
    geolocalitzacio3?: string;
    geolocalitzacio4?: string;
    geolocalitzacio5?: string;
    pages?: number;
    destinated_users?: number;
    emails?: string[];
    emails_admin?: string[];
    emails_qr?: string[];
    path?: string;
    qr_link?: string;
    constructor(
        id: string,
        name: string,
        code: string,
        activation_code: string,
        visible: boolean,
        roadbook_type: number,
        roadbook: string,
        filename: string,
        interes?: string,
        distancia?: number,
        duracio?: number,
        estacionalitat?: string,
        geolocalitzacio?: string,
        pages?: number,
        destinated_users?: number,
        emails?: string[],
        emails_admin?: string[],
        filenameGuide?: string,
        geolocalitzacio2?: string,
        geolocalitzacio3?: string,
        geolocalitzacio4?: string,
        geolocalitzacio5?: string,
        filenameGpx?: string,
        path?: string,
        emails_qr?: string[],
        qr_link?: string
    ) {
        this.id = id;
        this.name = name;
        this.code = code;
        this.activation_code = activation_code;
        this.visible = visible;
        this.roadbook_type = roadbook_type;
        this.roadbook = roadbook;
        this.filename = filename;
        this.filenameGuide = filenameGuide;
        this.filenameGpx = filenameGpx;
        this.interes = interes;
        this.distancia = distancia;
        this.duracio = duracio;
        this.estacionalitat = estacionalitat;
        this.geolocalitzacio = geolocalitzacio;
        this.geolocalitzacio2 = geolocalitzacio2 ? geolocalitzacio2 : null;
        this.geolocalitzacio3 = geolocalitzacio3 ? geolocalitzacio3 : null;
        this.geolocalitzacio4 = geolocalitzacio4 ? geolocalitzacio4 : null;
        this.geolocalitzacio5 = geolocalitzacio5 ? geolocalitzacio5 : null;
        this.pages = pages;
        this.destinated_users = destinated_users;
        this.emails = emails;
        this.emails_admin  = emails_admin;
        this.emails_qr  = emails_qr;
        this.path = path;
        this.qr_link = qr_link;
    }
}
